"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function PortfolioPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const projects = [{
    id: 1,
    title: "Modern Kitchen Transformation",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/modern_kitchen_renovation.png"
  }, {
    id: 2,
    title: "Luxury Bathroom Remodel",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/luxury_bathroom_remodel.png"
  }, {
    id: 3,
    title: "Contemporary Living Space",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/contemporary_living_renovation.png"
  }, {
    id: 4,
    title: "Master Suite Upgrade",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/master_suite_upgrade.png"
  }, {
    id: 5,
    title: "Open Concept Kitchen",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/open_concept_kitchen.png"
  }, {
    id: 6,
    title: "Spa-Inspired Bathroom",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/spa_inspired_bathroom.png"
  }];
  return <section ref={ref} className="py-16 sm:py-20 lg:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Recent Projects
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Explore our portfolio of completed renovations and see the quality craftsmanship that sets us apart.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {projects.map((project, i) => <Link key={project.id} to="/PortfolioProjectsPage" data-index={i} className={`group block transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <Card className="overflow-hidden shadow-soft hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 p-0">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-102" />
                  <div className="absolute inset-0 bg-dark-background/70 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] flex items-center justify-center p-6">
                    <h3 className="font-display text-xl sm:text-2xl font-semibold text-foreground-dark text-center">
                      {project.title}
                    </h3>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}